var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { default as emotionStyled } from '@emotion/styled';
import { useTheme, ContentDirection } from './index';
import rtlCSSJS from 'rtl-css-js';
var noop = function (styles) { return styles; };
export var convertToStaticStates = function (obj) {
    if (!obj) {
        return obj;
    }
    return Object.keys(obj).reduce(function (result, key) {
        var _a;
        var newKey = key
            .replace(/^:/, '&:')
            .replace(/,(\s+):/g, ',$1&:')
            .replace(/:(focus|hover|active)/g, '.$1')
            .replace(/\[data\-whatinput=("|')?(mouse|touch|keyboard|pointer)("|')?]/g, '[data-whatinput="noop"]');
        var value = typeof obj[key] === 'object' ? convertToStaticStates(obj[key]) : obj[key];
        var newObj = __assign(__assign({}, result), (_a = {}, _a[newKey] = value, _a));
        return newObj;
    }, {});
};
function styled(node) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var newArgs = args.map(function (interpolation) { return function (props) {
            props.theme = useTheme(props.theme);
            var direction = props.theme.canvas.direction;
            var maybeFlip = direction === ContentDirection.RTL ? rtlCSSJS : noop;
            var maybeConvert = props.theme._staticStates ? convertToStaticStates : noop;
            try {
                if (typeof interpolation === 'function') {
                    return maybeFlip(maybeConvert(interpolation(props)));
                }
                return maybeFlip(maybeConvert(interpolation));
            }
            catch (e) {
                return maybeConvert(interpolation);
            }
        }; });
        return emotionStyled(node)(newArgs);
    };
}
export default styled;
